/** Admin: hvem som styrer startklokka for regattaen. */
export type StartMode = 'fixed' | 'committee' | 'manual';

export function StartModeField({
  value,
  onChange,
}: {
  value: StartMode;
  onChange: (v: StartMode) => void;
}) {
  const option = (v: StartMode, title: string, text: string) => (
    <label
      className={`flex items-start gap-2 p-2.5 border rounded-lg cursor-pointer text-sm ${
        value === v ? 'border-sky-600 bg-sky-900/30' : 'border-slate-700 bg-slate-950'
      }`}
    >
      <input
        type="radio"
        name="startMode"
        checked={value === v}
        onChange={() => onChange(v)}
        className="mt-0.5 accent-sky-500"
      />
      <span>
        <span className="font-semibold text-slate-100">{title}</span>
        <span className="block text-xs text-slate-400">{text}</span>
      </span>
    </label>
  );
  return (
    <div>
      <label className="block text-xs text-slate-400 mb-1">Startklokke</label>
      <div className="grid gap-2 sm:grid-cols-3">
        {option(
          'fixed',
          'Fast starttid',
          'Klokka følger regattaens starttid for alle — 5 min prosedyre med flagg og lyd.',
        )}
        {option(
          'committee',
          'Komiteen starter klokka',
          'Komiteen trykker «5 min» på regattasiden eller i appen — alle båter følger samme klokke.',
        )}
        {option(
          'manual',
          'Båtene starter klokka',
          'Hver båt starter klokka selv med knappene når komiteens signal går.',
        )}
      </div>
    </div>
  );
}
